export default "__VITE_ASSET__rydO6n6d__"